export const loginInfoDataText = "로그인 정보 입력";
export const kakaoLoginText = "카카오 로그인";
